import React, { FC } from 'react';
import { FieldState } from 'formstate';
import { IItem, VSearchSelectField, VSearchSelectFieldAsync } from 'welltrax-ui-components';
import { Icon } from '@blueprintjs/core';
import { isNil } from 'lodash';
import { useMeasure } from 'react-use';

import { intl } from '../../../../../core/utils/Intl';
import { ILayer } from 'welltrax-ui-components/lib/types/Form/Inputs/ILayer';
import { LoadData } from 'welltrax-ui-components/lib/types/Form/Inputs/SearchSelectAsync/VSearchSelectFieldAsync';

type Props = {
  id: string;
  label?: string;
  fieldState?: FieldState<any>;
  value?: any;
  isLargeDataSetEnabled: boolean;
  options: IItem[];
  validators?: any[];
  displayRequired?: boolean;
  disabled?: boolean;
  required?: boolean;
  layer?: ILayer;
  allowEmpty?: boolean;
  isLoading?: boolean;
  popoverWidth?: number;
  amountCharacterSearch?: number;
  allowFirstLoad?: boolean;
  onLoadData: (params: LoadData) => Promise<IItem[]>;
  onChange?: (value: any) => void;
  placeholder?: string;
  fixedInputWidthPx?: number; //incluir al largeDataSet
  tipLabel?: string;
  margin?: string;
  noLabel?: boolean;
  inline?: boolean;
  minimal?: boolean;
  multi?: boolean;
  sort?: 'desc' | 'asc';
};

const SearchSelectLargeData: FC<Props> = ({
  id,
  label,
  layer,
  options,
  disabled,
  required,
  isLoading,
  allowEmpty,
  fieldState,
  value,
  validators,
  popoverWidth,
  displayRequired,
  isLargeDataSetEnabled,
  amountCharacterSearch,
  allowFirstLoad,
  margin,
  noLabel,
  inline,
  minimal,
  tipLabel,
  multi,
  sort,
  onLoadData,
  onChange
}) => {
  const [refInputComponent, { width: widthComponent }] = useMeasure();

  return (
    <div ref={refInputComponent}>
      {isLargeDataSetEnabled ? (
        <VSearchSelectFieldAsync
          {...{
            id,
            label,
            validators,
            disabled,
            required,
            displayRequired,
            layer,
            allowEmpty,
            amountCharacterSearch,
            fieldState,
            value,
            margin,
            noLabel,
            inline,
            minimal,
            onLoadData,
            tipLabel,
            multi,
            sort,
            isLoading,
            onChange
          }}
          fill
          className="async-select"
          placeholderSearch={intl('app.placeholverSelectLargueData', 'Type "{count}" characters...', {
            count: amountCharacterSearch ?? 3
          })}
          rightIcon={<Icon icon={'search'} style={{ margin: '7px 5px' }} />}
          suppessLeftIconSearch
          popoverWidth={
            popoverWidth ?? (!isNil(widthComponent) ? (widthComponent > 400 ? 400 : widthComponent - 10) : undefined)
          }
          allowFirstLoad={allowFirstLoad ?? false}
        />
      ) : (
        <VSearchSelectField
          {...{
            id,
            label,
            validators,
            disabled,
            displayRequired,
            layer,
            required,
            allowEmpty,
            fieldState,
            value,
            margin,
            noLabel,
            inline,
            isLoading,
            onChange,
            options,
            minimal,
            tipLabel,
            multi,
            sort
          }}
          fill
          popoverWidth={!isNil(widthComponent) ? widthComponent - 10 : undefined}
        />
      )}
    </div>
  );
};

export default SearchSelectLargeData;
